'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
var defineProperty = require('../../defineProperty-3cad0327.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var direction = xstyledStyledComponents_es.style({
  prop: 'direction',
  cssProperty: 'flexDirection'
});
var wrap = xstyledStyledComponents_es.style({
  prop: 'wrap',
  cssProperty: 'flexWrap'
});
var alignItems = xstyledStyledComponents_es.style({
  prop: 'alignItems'
});
var alignSelf = xstyledStyledComponents_es.style({
  prop: 'alignSelf'
});
var justify = xstyledStyledComponents_es.style({
  prop: 'justify',
  cssProperty: 'justifyContent'
});
var spacingTop = xstyledStyledComponents_es.style({
  prop: 'spacingTop',
  cssProperty: 'paddingTop',
  themeGet: xstyledStyledComponents_es.getSpace
});
var spacingBottom = xstyledStyledComponents_es.style({
  prop: 'spacingBottom',
  cssProperty: 'paddingBottom',
  themeGet: xstyledStyledComponents_es.getSpace
});
var spacingRight = xstyledStyledComponents_es.style({
  prop: 'spacingRight',
  cssProperty: 'paddingRight',
  themeGet: xstyledStyledComponents_es.getSpace
});
var spacingLeft = xstyledStyledComponents_es.style({
  prop: 'spacingLeft',
  cssProperty: 'paddingLeft',
  themeGet: xstyledStyledComponents_es.getSpace
});
var spacingHorizontal = xstyledStyledComponents_es.style({
  prop: 'spacingHorizontal',
  cssProperty: ['paddingRight', 'paddingLeft'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var spacingVertical = xstyledStyledComponents_es.style({
  prop: 'spacingVertical',
  cssProperty: ['paddingTop', 'paddingBottom'],
  themeGet: xstyledStyledComponents_es.getSpace
});

function getColGuttersStyle(props, gutters) {
  if (!props.col) return false;

  if (xstyledStyledComponents_es.obj(gutters)) {
    var breakpointsStyle = xstyledStyledComponents_es.reduceBreakpoints(props, gutters, function (breakpointValue) {
      return {
        paddingRight: "".concat(xstyledStyledComponents_es.getSpace(breakpointValue)(props)),
        paddingLeft: "".concat(xstyledStyledComponents_es.getSpace(breakpointValue)(props))
      };
    });
    return _extends._extends_1({}, breakpointsStyle);
  }

  return {
    paddingRight: "".concat(xstyledStyledComponents_es.getSpace(gutters)(props)),
    paddingLeft: "".concat(xstyledStyledComponents_es.getSpace(gutters)(props))
  };
}

function getRowGuttersStyle(props, gutters) {
  if (!props.row) return false;

  if (xstyledStyledComponents_es.obj(gutters)) {
    var breakpointsStyle = xstyledStyledComponents_es.reduceBreakpoints(props, gutters, function (breakpointValue) {
      return {
        paddingTop: "".concat(xstyledStyledComponents_es.getSpace(breakpointValue)(props)),
        paddingBottom: "".concat(xstyledStyledComponents_es.getSpace(breakpointValue)(props))
      };
    });
    return _extends._extends_1({}, breakpointsStyle);
  }

  return {
    paddingTop: "".concat(xstyledStyledComponents_es.getSpace(gutters)(props)),
    paddingBottom: "".concat(xstyledStyledComponents_es.getSpace(gutters)(props))
  };
}

function getColStyle(props, size) {
  if (size === 'fill') {
    return {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: '100%'
    };
  }

  if (size === 'auto') {
    return {
      flex: '0 0 auto',
      maxWidth: 'none',
      width: 'auto'
    };
  }

  var sizeWidth = xstyledStyledComponents_es.getPercent(size / 12)(props);
  return {
    flex: "0 0 ".concat(sizeWidth),
    maxWidth: sizeWidth
  };
}

var getOffsetStyle = function getOffsetStyle(props, size) {
  if (size === 'auto') {
    return {
      marginLeft: 'auto'
    };
  }

  var sizeWidth = xstyledStyledComponents_es.getPercent(size / 12)(props);
  return {
    marginLeft: sizeWidth
  };
};

var componentBaseStyles = {
  row: function row(props) {
    var guttersValue = props.gutters;
    var common = {
      boxSizing: 'border-box',
      flexGrow: 1,
      flexWrap: 'wrap',
      display: 'flex'
    };
    return _extends._extends_1({}, common, getRowGuttersStyle(props, guttersValue));
  },
  col: function col(props) {
    var colValue = props.col;
    var guttersValue = props.gutters;
    var common = {
      boxSizing: 'border-box',
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: '100%'
    };

    if (xstyledStyledComponents_es.obj(colValue)) {
      var breakpointsStyleCol = xstyledStyledComponents_es.reduceBreakpoints(props, colValue, function (breakpointValue) {
        return getColStyle(props, breakpointValue);
      });
      var breakpointsStyleGutters = getColGuttersStyle(props, guttersValue);
      var breakpointsStyle = xstyledStyledComponents_es.merge(breakpointsStyleCol, breakpointsStyleGutters);
      return _extends._extends_1({}, common, breakpointsStyle);
    }

    return _extends._extends_1({}, common, getColStyle(props, colValue), getColGuttersStyle(props, guttersValue));
  },
  offset: function offset(props) {
    var offsetvalue = props.offset;

    if (xstyledStyledComponents_es.obj(offsetvalue)) {
      var breakpointsStyle = xstyledStyledComponents_es.reduceBreakpoints(props, offsetvalue, function (breakpointValue) {
        return getOffsetStyle(props, breakpointValue);
      });
      return _extends._extends_1({}, breakpointsStyle);
    }

    return _extends._extends_1({}, getOffsetStyle(props, offsetvalue));
  }
};

var createStyleProps = function createStyleProps(componentName) {
  return xstyledStyledComponents_es.createStyleGenerator(function (props) {
    return _extends._extends_1({}, props[componentName] && componentBaseStyles[componentName](props));
  }, [componentName]);
};

var row = createStyleProps('row');
var col = createStyleProps('col');
var offset = createStyleProps('offset');
var styleProps = xstyledStyledComponents_es.compose(col, row, wrap, alignItems, alignSelf, justify, direction, xstyledStyledComponents_es.order, spacingTop, spacingBottom, spacingRight, spacingLeft, spacingHorizontal, spacingVertical, offset, xstyledStyledComponents_es.backgrounds);
var InnerGrid = xstyledStyledComponents_es.createSystemComponent(React__default['default'], 'div', styleProps);
var GridWrapper = xstyledStyledComponents_es.styled(InnerGrid).withConfig({
  shouldForwardProp: function shouldForwardProp(prop, validate) {
    return validate(prop) && !styleProps.meta.props.includes(prop);
  }
})(_templateObject(), styleProps);

function getSystemPropTypes(system) {
  if (!system) return {};
  return system.meta.props.reduce(function (result, prop) {
    return _extends._extends_1({}, result, defineProperty.defineProperty({}, prop, index.propTypes.oneOfType([index.propTypes.number, index.propTypes.string, index.propTypes.object, index.propTypes.bool])));
  }, {});
}

GridWrapper.displayName = 'GridWrapper';
GridWrapper.propTypes = getSystemPropTypes(styleProps);

function Grid(_ref) {
  var children = _ref.children,
      tag = _ref.tag,
      row = _ref.row,
      col = _ref.col,
      offset = _ref.offset,
      spacing = _ref.spacing,
      spacingBottom = _ref.spacingBottom,
      spacingHorizontal = _ref.spacingHorizontal,
      spacingLeft = _ref.spacingLeft,
      spacingRight = _ref.spacingRight,
      spacingTop = _ref.spacingTop,
      spacingVertical = _ref.spacingVertical,
      rest = objectWithoutProperties.objectWithoutProperties(_ref, ["children", "tag", "row", "col", "offset", "spacing", "spacingBottom", "spacingHorizontal", "spacingLeft", "spacingRight", "spacingTop", "spacingVertical"]);

  var gridProps = _extends._extends_1({
    forwardedAs: tag,
    row: row,
    col: col,
    offset: offset,
    spacingBottom: spacingBottom,
    spacingHorizontal: spacingHorizontal,
    spacingLeft: spacingLeft,
    spacingRight: spacingRight,
    spacingTop: spacingTop,
    spacingVertical: spacingVertical,
    gutters: ['0x', 0].includes(spacing) ? {} : spacing
  }, rest);

  return /*#__PURE__*/React__default['default'].createElement(GridWrapper, gridProps, React__default['default'].Children.map(children, function (child) {
    if (child.props && child.props.col) {
      return /*#__PURE__*/React__default['default'].cloneElement(child, {
        spacing: spacing
      });
    }

    return child;
  }));
}

Grid.defaultProps = {
  tag: undefined,
  className: undefined,
  children: null,
  row: undefined,
  col: undefined,
  spacing: {
    xs: '2x',
    md: '4x'
  },
  spacingBottom: undefined,
  spacingHorizontal: undefined,
  spacingLeft: undefined,
  spacingRight: undefined,
  spacingTop: undefined,
  spacingVertical: undefined,
  offset: undefined,
  direction: undefined,
  justify: undefined,
  alignItems: undefined,
  alignSelf: undefined
};
Grid.propTypes = {
  /** Use alignItems in Row to set the vertical alignment  */
  alignItems: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Use alignSelf in Col to set the vertical alignment  */
  alignSelf: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** The content of the component, it can be either another component or raw text */
  children: index.propTypes.oneOfType([index.propTypes.node, index.propTypes.func]),

  /** The class that will be applied to the HTML element */
  className: index.propTypes.string,

  /** Cols based on a 12-column grid layout */
  col: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Use direction in Row to set directions cols */
  direction: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Use justify in Row to set the horizontal alignment  */
  justify: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Use offset to move columns to the right */
  offset: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Rows are wrappers for columns. */
  row: index.propTypes.oneOfType([index.propTypes.bool]),

  /** The responsive grid focuses on consistent spacing widths, rather than column width */
  spacing: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Use spacingBottom in Row or Col to set the spacing top  */
  spacingBottom: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Use spacingHorizontal in Row or Col to set the spacing top  */
  spacingHorizontal: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Use spacingleft in Row or Col to set the spacing top  */
  spacingLeft: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Use spacingRight in Row or Col to set the spacing top  */
  spacingRight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Use spacingTop in Row or Col to set the spacing top  */
  spacingTop: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** Use spacingVertical in Row or Col to set the spacing top  */
  spacingVertical: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),

  /** The actual HTML element to be rendered */
  tag: index.propTypes.elementType
};

exports.default = Grid;
//# sourceMappingURL=DeprecatedGrid.js.map
